import { Component, OnInit, Input } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController, ModalController, PopoverController } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { ListarFormatosGenericosService } from './listar-formatos-genericos.services';
import { RxStompService} from '@stomp/ng2-stompjs';

@Component({
  selector: 'app-listar-formatos-genericos',
  templateUrl: './listar-formatos-genericos.page.html',
  styleUrls: ['./listar-formatos-genericos.page.scss'],
  providers:[TranslateService, GeneralServices, ListarFormatosGenericosService]
})
export class ListarFormatosGenericosPage implements OnInit {

  public loader;
  public formatos_Array;
  public dataUser;

  @Input() Estudio;
  @Input() receptorIdHefesto;

  constructor(private platform: Platform, 
    private translate: TranslateService, 
    private _generalServices:GeneralServices,
    private loadingCtrl: LoadingController,
    private route: ActivatedRoute,
    private router:Router,
    public _listarFormatosGenericosService:ListarFormatosGenericosService,
    public modalController: ModalController,
    public popoverCtrl: PopoverController,
    private rxStompService: RxStompService) {
      this.dataUser=JSON.parse(sessionStorage.getItem('dataUser'))[0];
      this._generalServices.setLanguage(this.translate);
   }

  ngOnInit() {
    this.formatos_Array = [];
    this.loadFormatos();
  }

  loadFormatos(){
    let _thisClass=this;
  
      /*this.loader = this.loadingCtrl.create({
                      content: _thisClass.translate.instant('LOAD_MSG_INICIAR_SESION'),
                    });
      this.loader.present();*/
  
      
      this._listarFormatosGenericosService.getFormatosGenericos().subscribe(
      result => {
            this.formatos_Array = result;
            console.log(result);
                
      },
      error =>{
        this._generalServices.errorManager(error,_thisClass.loader,false);
      }
      );
  }

  enviarFormato(formato){
    
    var header = '{"IdFormatoGenerico": "'+formato.Id+'", "Estudio": "'+this.Estudio+'","Tipo":"Historia", "IdUsuario": "'+this.dataUser.IdUsuario+'", "NombreUserHefesto": "'+this.dataUser.NombreUserHefesto+'"}';
    console.log(this.receptorIdHefesto);
    this.rxStompService.publish({destination: '/topic/Zeus.Hefesto.UserTopic.genericFormat_'+this.receptorIdHefesto, body: header});
    this.modalController.dismiss();
  }

  closeModal(){
    this.modalController.dismiss();
  }

}
